import React from 'react';

// eslint-disable-next-line max-len
const DREAMLAB_LOGO = '/themes/theme/dreamlab/logo.png';
const DREAMLAB_DARK_LOGO = '/themes/theme/dreamlab/logo_dark.png';

const DreamlabTheme = {
  headerLogo: {
    src: DREAMLAB_LOGO,
    alt: 'Dream Lab Logo',
    size: 70,
  },
  darkLogo: {
    src: DREAMLAB_LOGO,
    alt: 'Dream Lab Logo',
    size: 70,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '4px solid #ffff',
    height: 80,
  },
  title: 'Dream Lab',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={DREAMLAB_DARK_LOGO} alt="Dream Lab Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://reports.dreamlabstudio.co.uk',
};

export default DreamlabTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/dreamlab.js
 **/